trackerRun.$inject = ['$rootScope', 'tracker'];
function trackerRun($rootScope, tracker) {
  $rootScope.$on('$routeChangeStart', function(event, current, previous) {
    //// only track routes which won't cause an $routeChangeSuccess,
    //// but are valid routes
    // BE CAUTIOUS HERE WITH CHANGES
    // info: some pages use a 'details' view which will change the route
    // e.g. /core/farm <-> /core/farm/:id, /planning/croppplanning <-> /planning/croppplanning/:scenarioid
    // but this have different implementations for the details view
    // which can lead to wrong (double) tracking
    // as for now the code below works with the distinct routes
    // but adaption may be needed if the 'details view' implementation changes for a route

    // dont't track redirects (e.g. login.html -> login.html#/)
    if (current.redirectTo !== undefined) {
      return;
    }

    // must have current and previous
    if (previous === undefined || current === undefined) {
      return;
    }

    // if route does not exist the $$route won't be set
    if (
      !current.hasOwnProperty('$$route') ||
      !previous.hasOwnProperty('$$route')
    ) {
      return;
    }

    var currentPath = current.$$route ? current.$$route.originalPath : '';
    var previousPath = previous.$$route ? previous.$$route.originalPath : '';

    // don't track here optional parameters which aren't set
    // e.g. for /booking/field/:id?, /myFarmMap/:layerId?, /booking/activity/:id?
    // these are not master/details views an generate an $routeChangeEnd
    var optParamRegEx = /:([^\/]+\?)/; //  /?:\/([^\/]+)?)/;
    if (currentPath.match(optParamRegEx)) {
      return;
    }

    // should have parameter (e.g. :id)
    // and be on the same path (true for details views and back)
    if (currentPath.indexOf('/:') === -1 && currentPath !== previousPath) {
      return;
    }

    // track current route since it will not be available
    // on $routeChangeSuccess
    tracker.trackRoute(current);
  });

  $rootScope.$on('$routeChangeSuccess', function(event, current, previous) {
    //// Avoid double tracking:
    // dont't track redirects (e.g. login.html -> login.html#/)
    if (current.redirectTo !== undefined) {
      return;
    }

    // e.g. /core/farm/ will be redirected to /core/farm
    // and would generate a double entry in piwik
    // should be handled by redirects check above - but one never knows...
    var currentPath = current.$$route ? current.$$route.originalPath : '';
    var previousPath;
    if (previous && previous.$$route) {
      previousPath = previous ? previous.$$route.originalPath : '';
    } else {
      previousPath = '';
    }

    if (previousPath === currentPath + '/') {
      return;
    }

    //// and track
    tracker.trackRoute(current);
  });
}

export default trackerRun;
